import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import {
    FertilizerProductId,
    FertilizerProductPerUnitType
} from 'services/fertilizerEvents/types';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import {
    makeSelectProductRatePerArea,
    makeSelectProductUnitType
} from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
    perUnitType: FertilizerProductPerUnitType;
}

type Props = OwnProps;

export default function ProductRatePerAreaTableCell(
    props: Props
): React.ReactElement {
    const { perUnitType } = props;

    const productUnitType = useSelector((state: AppState) =>
        makeSelectProductUnitType()(state, props)
    );
    const productRatePerArea = useSelector((state: AppState) =>
        makeSelectProductRatePerArea()(state, props)
    );

    return (
        <TableCell>
            {`${productRatePerArea} ${productUnitType}/${perUnitType}`}
        </TableCell>
    );
}
